import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { WorkbenchPreviewThreeComponent } from './preview-three.component';

@NgModule({
  declarations: [
    WorkbenchPreviewThreeComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule
  ],
  exports: [
    WorkbenchPreviewThreeComponent
  ]
})
export class WorkbenchPreviewModule { }
